import styled from "styled-components"
import { useDispatch } from 'react-redux'
import TabSide from '../../components/messageAndNotifications/TabSide'
import MessageSide from '../../components/messageAndNotifications/MessageSide'
import { useEffect } from 'react'
import { getClosedChats, getNonClosedChats } from '../../features/messages/messageSlice'
import NotificationTabSide from "../../components/messageAndNotifications/NotificationTabSide"
import NotificationMessageSide from "../../components/messageAndNotifications/NotificationMessageSide"

const Container = styled.div`

width: 100%;

    .wrapper{
      display: flex;
      justify-content: space-between;
      padding: 30px;
    }
`

const Notification = () => {
  const dispatch = useDispatch()

  return (
    <Container>
      <div className="wrapper">
        <NotificationTabSide />
        <NotificationMessageSide />
      </div>
    </Container>
  )
}

export default Notification